module.exports = __webpack_public_path__ + "img/300.638ddd40.png";